module.exports = __webpack_public_path__ + "static/media/nft-GradientBlob.460895ad.png";